import { Button } from '@ipfabric/ui-components/Button/Button';
import { Icon } from '@ipfabric/ui-components/Icon/Icon';

type Props = {
  invalidCount: number;
  showOnlyInvalid: boolean;
  onToggle: () => void;
  invalidLabel: string;
};

export const AimInvalidBanner = ({
  invalidCount,
  showOnlyInvalid,
  onToggle,
  invalidLabel,
}: Props) => {
  if (invalidCount === 0) {
    return null;
  }
  return (
    <div className='flex flex-row items-center gap-x bg-warning-light px-4 py-2 rounded-lg'>
      <Icon glyph='fa-exclamation-triangle' className='text-warning' />
      <span className='flex-1'>
        {invalidCount} {invalidLabel}.
      </span>
      <Button variant='outline' size='small' onClick={onToggle}>
        {showOnlyInvalid ? 'Show all' : `Show only invalid (${invalidCount})`}
      </Button>
    </div>
  );
};
